export default {
    url: '/course-progress',
    template: '<reports-courseprogress classifiers="vm.classifiers" sites="vm.sites"/>',
    resolve: {
        sites: (SiteResource) => SiteResource.query({ reportUserCourseProgressSites: true, pageSize: 0 }).$promise
    },
    controller (classifiers, sites) {
        this.classifiers = classifiers;
        this.sites = sites;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/courseprogress/index.js